import { Link } from 'react-router-dom'

import {
  IconButton,
  Tooltip,
  TooltipAlign,
  TooltipPosition,
  Checkbox,
} from '@loadsmart/loadsmart-ui'
import { Button, Layout, Text } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import user from 'legacy/utils/user'

import { type Proposal } from '../domain/Proposal'
import { getAutoSubmitLabel } from '../presenters/rfpAwardedPresenter'
import { ActionsWrapper, ContentWrapper, ScrollWrapper } from './RfpDetails.styles'

export type AwardedProposalHeaderProps = {
  awardedProposal: Proposal
  autoSubmitDisabled: boolean
  fixed: boolean
  awardAutoSubmitChecked: boolean
  submitDisabled: boolean
  onSubmit: () => void
  onToggleAutoSubmit: () => void
}

export function AwardedProposalHeader({
  autoSubmitDisabled,
  awardedProposal,
  fixed,
  awardAutoSubmitChecked,
  submitDisabled,
  onSubmit,
  onToggleAutoSubmit,
}: AwardedProposalHeaderProps) {
  const { rfp } = awardedProposal
  const { name, shipperName } = rfp

  return (
    <ScrollWrapper $fixed={fixed} data-testid="scroll-wrapper">
      <ContentWrapper>
        {user.isLoggedIn() && (
          // @ts-expect-error
          <IconButton as={Link} to={'/all-in-one/rfp'} scale={'small'}>
            <Icon name="arrow-left" />
          </IconButton>
        )}
        <Layout.Stack gap="none">
          <Text variant="heading-md-bold">{`${shipperName} - ${name}`}</Text>
          <Text variant="body-md">Accept or reject it below and start receiving tenders.</Text>
        </Layout.Stack>
        <ActionsWrapper align="center" justify="flex-end">
          <Checkbox
            disabled={autoSubmitDisabled}
            checked={awardAutoSubmitChecked}
            onChange={onToggleAutoSubmit}
            trailing={
              <Tooltip
                message="When the deadline expires, your answer will be sent automatically"
                position={TooltipPosition.Bottom}
                align={TooltipAlign.End}
              >
                <Icon name="question-circle" />
              </Tooltip>
            }
          >
            {getAutoSubmitLabel(awardedProposal)}
          </Checkbox>
          <Button type="button" variant="primary" onClick={onSubmit} disabled={submitDisabled}>
            Submit
          </Button>
        </ActionsWrapper>
      </ContentWrapper>
    </ScrollWrapper>
  )
}
